import http from '../http-common';

/** API origin for storage assets (logos, images), not the React dev server. */
export const getApiOrigin = () => {
  if (typeof window === 'undefined') return '';
  const baseURL = http.defaults?.baseURL;
  if (baseURL) {
    try {
      return new URL(baseURL, window.location.origin).origin;
    } catch {
      /* fall through */
    }
  }
  return window.location.origin;
};

export const resolveAbsoluteUrl = (url) => {
  if (!url) return null;
  if (/^https?:\/\//i.test(url)) return url;
  const origin = getApiOrigin();
  return `${origin}${url.startsWith('/') ? url : `/${url}`}`;
};
